import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/AppShell";
import { AuthProvider } from "@/components/AuthProvider";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AccountPage from "@/pages/AccountPage";
import AuditLogsPage from "@/pages/AuditLogsPage";
import DashboardPage from "@/pages/DashboardPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import InstallerDownloadPage from "@/pages/InstallerDownloadPage";
import LoginPage from "@/pages/LoginPage";
import ManagersPage from "@/pages/ManagersPage";
import ReportsPage from "@/pages/ReportsPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import StoresPage from "@/pages/StoresPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<InstallerDownloadPage />} path="/" />
          <Route element={<LoginPage />} path="/login" />
          <Route element={<ForgotPasswordPage />} path="/forgot-password" />
          <Route element={<ResetPasswordPage />} path="/reset-password" />
          <Route element={<ProtectedRoute />}>
            <Route element={<AppShell />}>
              <Route element={<DashboardPage />} path="/dashboard" />
              <Route element={<StoresPage />} path="/stores" />
              <Route element={<ReportsPage />} path="/reports" />
              <Route element={<ManagersPage />} path="/managers" />
              <Route element={<AuditLogsPage />} path="/audit" />
              <Route element={<AccountPage />} path="/account" />
            </Route>
          </Route>
          <Route element={<Navigate replace to="/" />} path="*" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
